const SUBSCRIPTION_STATUS_LABELS = {
  incomplete: 'Incomplete',
  trialing: 'Trialing',
  scheduled: 'Scheduled',
  active: 'Active',
  completed: 'Completed',
  past_due: 'Overdue',
  canceled: 'Canceled',
  incomplete_expired: 'Failed',
  unpaid: 'Failed',
  failed: 'Failed',
};

export default function getSubscriptionStatusLabel(status) {
  return SUBSCRIPTION_STATUS_LABELS[status] || 'Unknown';
}
